let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fzqcj")).then(() => parcelRequire('N3UrL'));